import SkewedLayers from './SkewedLayers';

function EnvelopeLayers() {
  return (
    <SkewedLayers
      layers={[
        {
          src: '/images/stacking-contexts/envelope/envelope-layer-back.svg',
          name: '1. Back Pane',
        },
        {
          src: '/images/stacking-contexts/envelope/envelope-layer-content.svg',
          name: '2. Letter',
        },
        {
          src: '/images/stacking-contexts/envelope/envelope-layer-shell.svg',
          name: '3. Shell',
        },
        {
          src: '/images/stacking-contexts/envelope/envelope-layer-flap.svg',
          name: '4. Flap',
        },
      ]}
    />
  );
}

export default EnvelopeLayers;
